import { MutableRefObject } from 'react';

import {
  Button,
  Loader,
  ModalContainer,
  ModalLayoutCenter,
} from '@kanda-libs/ks-design-library';

import { CHANGE_TO_OB_MODAL_ID } from './constants';
import useChangeToOpenBankingModal from './useChangeToOpenBankingModal';

const ChangeToOpenBankingModal: React.FunctionComponent = function () {
  const { onClick, disabled, isSubmitting } = useChangeToOpenBankingModal();
  return (
    <>
      <ModalContainer id={CHANGE_TO_OB_MODAL_ID} opacity={40}>
        {({ id, handleClose, ref }) => (
          <ModalLayoutCenter
            id={id}
            onClose={handleClose}
            ref={ref as MutableRefObject<HTMLDivElement>}
            className="w-11/12 md:w-160"
          >
            <div className="flex flex-col gap-y-4">
              <div className="w-full pr-8">
                <h2 className="text-16-24-em">Pay with Open Banking</h2>
              </div>
              <h3 className="text-14-22">
                Open Banking is a secure, easy and fast way to pay your deposit
                with Ideal4Finance. If you&apos;d prefer to pay via Open Banking
                than by card, just click the button below
              </h3>
              <Button.Text
                id="change-to-ob"
                label="Pay Deposit by Open Banking"
                onClick={onClick}
                disabled={disabled}
              />
            </div>
          </ModalLayoutCenter>
        )}
      </ModalContainer>
      <Loader isLoading={isSubmitting} />
    </>
  );
};

export default ChangeToOpenBankingModal;
